// Turn a Job Library entry into job-description text, exactly as the
// tailoring studio does (ResumeTailoringClaudeDirect handleJobSelection /
// buildCompleteJd). Keep the two in step.
//
//  - tailoringJd: what the resume is TAILORED to, the selected items only
//    (the ones the member confirmed they have done).
//  - completeJd:  the full job; the tailored resume is always SCORED against
//    this, never the selected subset.
import type { SavedJobDescription } from "@/services/jobLibraryService";

export function tailoringJdFromSavedJob(job: SavedJobDescription): string {
  return `Company: ${job.companyName}
Job Title: ${job.jobTitle}
Company Mission: ${job.companyMission}

Key Responsibilities:
${job.selectedResponsibilities.map((resp) => `• ${resp}`).join("\n")}

Requirements:
${job.selectedRequirements.map((req) => `• ${req}`).join("\n")}

Required Skills:
${job.selectedSkills.map((skill) => `• ${skill}`).join("\n")}`;
}

export function completeJdFromSavedJob(job: SavedJobDescription): string {
  return `MODIFIED JOB DESCRIPTION - ${job.jobTitle}
Company Name: ${job.companyName}
Company Mission: ${job.companyMission}

Top Responsibilities (ranked by importance):
${(job.allResponsibilities ?? []).map((resp, i) => `${i + 1}. ${resp}`).join("\n")}

Top Requirements (ranked by importance):
${(job.allRequirements ?? []).map((req, i) => `${i + 1}. ${req}`).join("\n")}

Top Skills (ranked by importance):
${(job.allSkills ?? []).map((skill, i) => `${i + 1}. ${skill}`).join("\n")}`;
}
